import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/rechargeGift/blue_calender.png'
import _imports_1 from '@/assets/rechargeGift/green_calender.png'
import _imports_2 from '@/assets/rechargeGift/red_calender.png'
import _imports_3 from '@/assets/rechargeGift/coin.png'


const _hoisted_1 = { class: "calendar-wrapper" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  width: "100%",
  height: "100%",
  style: {"border-radius":"10px"}
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  width: "100%",
  height: "100%",
  style: {"border-radius":"10px"}
}
const _hoisted_4 = {
  key: 2,
  src: _imports_2,
  height: "100%",
  width: "100%",
  style: {"border-radius":"10px"}
}
const _hoisted_5 = { class: "calendar" }
const _hoisted_6 = { class: "cal-header" }
const _hoisted_7 = { class: "cal-body" }
const _hoisted_8 = { class: "month" }
const _hoisted_9 = { class: "day" }
const _hoisted_10 = {
  class: "dayTitle",
  style: {"font-size":"12px"}
}
const _hoisted_11 = { class: "givenAmount" }
const _hoisted_12 = {
  key: 0,
  style: {"color":"#0484ff"}
}
const _hoisted_13 = {
  key: 1,
  style: {"color":"#36d836"}
}
const _hoisted_14 = {
  key: 2,
  style: {"color":"#ff0000"}
}
const _hoisted_15 = {
  key: 3,
  style: {"color":"#ff0000"}
}

import { checkDate, dayFormat, formatCurrency, } from '@/utils/commonFunction';
import { getAmountSum } from '@/view/components/supportFunction';
import { computed, PropType, ref, } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'cashbackHistoryCard',
  props: {
    dayCount: {
        type: Number,
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    createTime: {
        type: String,
        default: () => ""
    },
    availableAmount: {
        type: Number,
        default: () => 0
    },
    title: {
        type: String,
        default: () => ""
    },
    totalAmount: {
        type: Number,
        default: () => 0
    },
    activityStatus: {
        type: Number
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    isShowDetails: {
        type: Boolean,
        default: () => true
    },
    givenAmount: {
        type: Number,
        default: () => 0
    },
},
  setup(__props) {

const props = __props
const dateObj = computed(() => {
    if (!props.createTime) return new Date();
    const dateString = props.createTime;
    return new Date(dateString);
});

const year = computed(() => dateObj.value.getFullYear());
const day = computed(() => dateObj.value.getDate());
const month = computed(() => dateObj.value.toLocaleString('en-US', { month: 'long' }));

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cardContainer", [
        __props.activityStatus == 1 ? 'status-border-success' : 
        __props.activityStatus == 2 || __props.activityStatus == 3 ? 'status-border-error' : 
        'status-border-pending'
     ]])
  }, [
    (!__props.isShowDetails)
      ? (_openBlock(), _createBlock(_component_van_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "3",
              class: "dayColumn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["check-badge", __props.activityStatus == 1 ? 'check-badge' : __props.activityStatus == 2 ? 'check-badge-2' : __props.activityStatus == 3 ? 'check-badge-2' : __props.activityStatus == 0 ? 'check-badge-1' : ''])
                }, [
                  (__props.activityStatus == 0)
                    ? (_openBlock(), _createBlock(_component_van_icon, {
                        key: 0,
                        name: "underway-o ",
                        color: "#4975c5"
                      }))
                    : _createCommentVNode("", true),
                  (__props.activityStatus == 1)
                    ? (_openBlock(), _createBlock(_component_van_icon, {
                        key: 1,
                        name: "success",
                        color: "#ffffff6b"
                      }))
                    : _createCommentVNode("", true),
                  (__props.activityStatus == 2 || __props.activityStatus == 3)
                    ? (_openBlock(), _createBlock(_component_van_icon, {
                        key: 2,
                        name: "cross",
                        color: "#ffadad"
                      }))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "4",
              class: "dayColumn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (__props.activityStatus == 0)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                    : _createCommentVNode("", true),
                  (__props.activityStatus == 1)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                    : _createCommentVNode("", true),
                  (__props.activityStatus == 2 || __props.activityStatus == 3)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(year.value), 1),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(month.value), 1),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(day.value), 1)
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "2",
              class: "topRow"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "line" }, null, -1)
              ])),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "8",
              class: "DataRow",
              style: {"margin":"10px 0"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('activity.givenAmount')), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createTextVNode(_toDisplayString(_unref(formatCurrency)(__props.givenAmount)) + " ", 1),
                  _cache[1] || (_cache[1] = _createElementVNode("img", {
                    src: _imports_3,
                    alt: "",
                    width: "15%",
                    style: {"padding-left":"5px"}
                  }, null, -1))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "7",
              class: "dayColumn",
              style: {"padding-right":"4%"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["status-badge", __props.activityStatus == 1 ? 'status-badge' : __props.activityStatus == 2 ? 'status-badge-2' : __props.activityStatus == 3 ? 'status-badge-2' : __props.activityStatus == 0 ? 'status-badge-1' : ''])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["check-badge", __props.activityStatus == 1 ? 'check-badge' : __props.activityStatus == 2 ? 'check-badge-2' : __props.activityStatus == 3 ? 'check-badge-2' : __props.activityStatus == 0 ? 'check-badge-1' : ''])
                  }, [
                    (__props.activityStatus == 0)
                      ? (_openBlock(), _createBlock(_component_van_icon, {
                          key: 0,
                          name: "underway-o ",
                          color: "#4975c5"
                        }))
                      : _createCommentVNode("", true),
                    (__props.activityStatus == 1)
                      ? (_openBlock(), _createBlock(_component_van_icon, {
                          key: 1,
                          name: "success",
                          color: "#ffffff6b"
                        }))
                      : _createCommentVNode("", true),
                    (__props.activityStatus == 2 || __props.activityStatus == 3)
                      ? (_openBlock(), _createBlock(_component_van_icon, {
                          key: 2,
                          name: "cross",
                          color: "#ffadad"
                        }))
                      : _createCommentVNode("", true)
                  ], 2),
                  (props.activityStatus == 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t('activityStatus.pending')), 1))
                    : (props.activityStatus == 1)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t('activityStatus.completed')), 1))
                      : (props.activityStatus == 2)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t('activityStatus.noRewards')), 1))
                        : (props.activityStatus == 3)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t('activity.overdue')), 1))
                          : _createCommentVNode("", true)
                ], 2)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})